module.exports = __webpack_public_path__ + "3c66f90ace7f76fb75fba89f6f82e078.svg";